/**
 * data-testid values shared by Playwright e2e and React components.
 * Keep in sync with playwright/test-utils/scheduling-flow-helpers.ts imports.
 */
export const E2E_SCHEDULING = {
	WIZARD_ROOT: 'e2e-scheduling-wizard-root',
	SERVICE_CARD_PREFIX: 'e2e-scheduling-service-',
	PROFESSIONAL_SELECT_PREFIX: 'e2e-scheduling-professional-select-',
	PROFESSIONALS_PAGE_NEXT: 'e2e-scheduling-professionals-page-next',
	PROFESSIONALS_PAGE_PREV: 'e2e-scheduling-professionals-page-prev',
	DATE_PICKER_ROOT: 'e2e-scheduling-date-picker',
	DAY_PREFIX: 'e2e-scheduling-day-',
	TIME_SLOT_PREFIX: 'e2e-scheduling-slot-',
	FOOTER_NEXT: 'e2e-scheduling-footer-next',
	FOOTER_BACK: 'e2e-scheduling-footer-back',
	REVIEW_MODAL_NEXT: 'e2e-scheduling-review-modal-next',
	PAYMENT_ROOT: 'e2e-scheduling-payment-root',
	/** Área rolável do ModalDrawer "Confirmar e pagar" (desktop + mobile). */
	PAYMENT_MODAL_SCROLL: 'e2e-scheduling-payment-modal-scroll',
	FIRST_SESSION_PROMO: 'e2e-scheduling-first-session-promo',
	FIRST_SESSION_PROMO_CODE: 'e2e-scheduling-first-session-promo-code',
	PAYMENT_STRIPE_COUPON_HINT: 'e2e-scheduling-payment-stripe-coupon-hint',
	PAYMENT_PAY_BUTTON: 'e2e-scheduling-payment-pay-button',
	PAYMENT_FINAL_VALUE: 'e2e-scheduling-payment-final-value',
	CLUB_SUBSCRIPTION_UPSELL: 'e2e-scheduling-club-subscription-upsell',
	CLUB_BENEFIT_SECTION: 'e2e-scheduling-club-benefit-section',
	CLUB_BENEFIT_PICKER_OPEN: 'e2e-scheduling-club-benefit-picker-open',
	BENEFIT_OPTION_PREFIX: 'e2e-scheduling-benefit-option-',
	CLUB_BENEFIT_PICKER_PANEL: 'e2e-scheduling-club-benefit-picker-panel',
	PUBLIC_AUTH_ROOT: 'e2e-scheduling-public-auth-root',
	AUTH_TAB_REGISTER: 'e2e-scheduling-auth-tab-register',
	AUTH_TAB_LOGIN: 'e2e-scheduling-auth-tab-login',
	AUTH_LOGIN_EMAIL: 'e2e-scheduling-auth-login-email',
	AUTH_LOGIN_PASSWORD: 'e2e-scheduling-auth-login-password',
	AUTH_REGISTER_EMAIL: 'e2e-scheduling-auth-register-email',
	AUTH_REGISTER_PASSWORD: 'e2e-scheduling-auth-register-password',
	AUTH_REGISTER_PASSWORD_REPEAT:
		'e2e-scheduling-auth-register-password-repeat',
	AUTH_SUBMIT: 'e2e-scheduling-auth-submit',
	AUTH_GOTO_LANDING_REGISTER: 'e2e-scheduling-auth-goto-landing-register',
	AUTH_GOTO_LANDING_LOGIN: 'e2e-scheduling-auth-goto-landing-login',
} as const;

export const E2E_USER_AUTH = {
	REGISTER_EMAIL: 'e2e-user-register-email',
	REGISTER_PASSWORD: 'e2e-user-register-password',
	REGISTER_PASSWORD_REPEAT: 'e2e-user-register-password-repeat',
	REGISTER_SUBMIT: 'e2e-user-register-submit',
	COMPLEMENT_FIRST_NAME: 'e2e-user-register-first-name',
	COMPLEMENT_LAST_NAME: 'e2e-user-register-last-name',
	COMPLEMENT_BIRTHDAY: 'e2e-user-register-birthday',
	COMPLEMENT_CPF: 'e2e-user-register-cpf',
	COMPLEMENT_PHONE: 'e2e-user-register-phone',
	COMPLEMENT_TERMS: 'e2e-user-register-terms',
	COMPLEMENT_SUBMIT: 'e2e-user-register-complement-submit',
	LOGIN_EMAIL: 'e2e-user-login-email',
	LOGIN_PASSWORD: 'e2e-user-login-password',
	LOGIN_SUBMIT: 'e2e-user-login-submit',
} as const;

export const E2E_HEADER = {
	FIRST_ACCESS: 'e2e-header-first-access',
	FIRST_ACCESS_MOBILE: 'e2e-header-first-access-mobile',
	OPEN_LOGIN_MENU: 'e2e-header-open-login-menu',
	LOGIN_COLLABORATOR: 'e2e-header-login-collaborator',
	LOGIN_COLLABORATOR_MOBILE: 'e2e-header-login-collaborator-mobile',
	MOBILE_MENU_OPEN: 'e2e-header-mobile-menu-open',
} as const;

export const E2E_USER_HOME = {
	SCHEDULE_BUTTON: 'e2e-user-home-schedule',
	SCHEDULE_BUTTON_EMPTY: 'e2e-user-home-schedule-empty',
	SESSION_PAY_PREFIX: 'e2e-user-home-session-pay-',
	SESSION_CARD_PREFIX: 'e2e-user-home-session-card-',
} as const;

export const E2E_LANDING = {
	SCHEDULE_CONSULTATION: 'e2e-landing-schedule-consultation',
} as const;

export const E2E_HEADER_USER = {
	LOGOUT: 'e2e-header-user-logout',
} as const;

/** Logout na sidebar (home logado com menu lateral). */
export const E2E_SIDEBAR_USER = {
	LOGOUT: 'e2e-sidebar-user-logout',
} as const;
